function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var BlobUpload = /*#__PURE__*/function () {
  function BlobUpload(blob) {
    var _this = this;

    _classCallCheck(this, BlobUpload);

    this.blob = blob;
    this.file = blob.file;
    var _blob$directUploadDat = blob.directUploadData,
        url = _blob$directUploadDat.url,
        headers = _blob$directUploadDat.headers;
    this.xhr = new XMLHttpRequest();
    this.xhr.open("PUT", url, true);
    this.xhr.responseType = "text";

    for (var key in headers) {
      this.xhr.setRequestHeader(key, headers[key]);
    }

    this.xhr.addEventListener("load", function (event) {
      return _this.requestDidLoad(event);
    });
    this.xhr.addEventListener("error", function (event) {
      return _this.requestDidError(event);
    });
  }

  _createClass(BlobUpload, [{
    key: "create",
    value: function create(callback) {
      this.callback = callback;
      this.xhr.send(this.file.slice());
    }
  }, {
    key: "requestDidLoad",
    value: function requestDidLoad(event) {
      var _this$xhr = this.xhr,
          status = _this$xhr.status,
          response = _this$xhr.response;

      if (status >= 200 && status < 300) {
        this.callback(null, response);
      } else {
        this.requestDidError(event);
      }
    }
  }, {
    key: "requestDidError",
    value: function requestDidError(event) {
      this.callback("Error storing \"".concat(this.file.name, "\". Status: ").concat(this.xhr.status));
    }
  }]);

  return BlobUpload;
}();